<template>
  <b-card class="card-congratulation-medal">
    <h5>{{ $t("dashboard.congratulations") }} 🎉!</h5>
    <b-card-text class="font-small-3">
      {{ $t("dashboard.this_month_revenue") }}
    </b-card-text>
    <h3 class="mb-75 mt-2 pt-50">
      <b-link>${{ kFormatter(data) }}</b-link>
    </h3>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-if="$can('read', 'booking')"
      variant="primary"
    >
      {{ $t("breadcrumb.viewBooking") }}
    </b-button>
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import { BCard, BCardText, BLink, BButton, BImg } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { kFormatter } from "@core/utils/filter";

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      default: () => 0,
    },
  },
  methods: {
    kFormatter,
  },
};
</script>
